export default __webpack_public_path__ + "media/images/features/jtb/mask-01cf8322dc62c62cb0d4feee039213c4.png";